import {WebFormModel} from "capitalist-shared/src/core/model";
import {WebFormModelInterface} from 'capitalist-shared/src/core/model';
import {VerificationTypes} from "@/models/verification/verification";
import axios from "axios";
import {RemoteRequestState} from "@/backoffice/components/pages/taxrules/taxrules";
import {UserProfile, UserProfileInterface} from "@/models/core/CoreState";

export interface SecurityActivationServiceDocumentInterface {
  id: number
  verificationType: VerificationTypes
  username: string
  dataForSign: string
  verificationRequired: boolean
}

export interface SecurityActivationModelInterface extends WebFormModelInterface {
  document?: SecurityActivationServiceDocumentInterface
}

export class GooglecodeSettingsModel extends WebFormModel {

  values: {
    seed: string,
    verificationType: VerificationTypes,
    activate: boolean,
    pin: string
  } = {
    seed: '',
    verificationType: null,
    activate: true,
    pin: ''
  }

  username = ''

  user: UserProfile | null = null;

  generatingStatus: RemoteRequestState = new RemoteRequestState();

  activationStatus: RemoteRequestState = new RemoteRequestState();

  activateCustom(seed: string, activate: boolean, verificationType: VerificationTypes = VerificationTypes.NONE): Promise<any> {
    this.values.seed = seed;
    this.values.activate = activate;
    this.values.verificationType = verificationType;
    return this.activate();
  }

  createDocument() {
    return this.activate();
  }

  activate(): Promise<any> {
    this.activationStatus.loadStart();
    return axios.post('/webapi/security/googlecode', {
      call: 'activate',
      m: this.values
    }).then((result) => {
      this.activationStatus.loadEnd();
      this._setData(result.data.model);
      return result.data.model;
    }).catch((err) => {
      this.checkAxiosError(err);
      this.activationStatus.loadError();
      throw err;
    })
  }

  // activateSms(): Promise<any> {
  //   this.values.verificationType = VerificationTypes.SMS;
  //   this.activationStatus.loadStart();
  //   return axios.post('/webapi/security/googlecode', {
  //     call: 'activate',
  //     m: this.values
  //   }).then((result) => {
  //     this.activationStatus.loadEnd();
  //     this._setData(result.data.model);
  //     return result.data.model.seed;
  //   }).catch((err) => {
  //     this.checkAxiosError(err);
  //     this.activationStatus.loadError();
  //     throw err;
  //   })
  // }


  regenerateSeed(): Promise<any> {
    this.generatingStatus.loadStart();
    return axios.post('/webapi/security/googlecode', {
      call: 'seed'
    }).then((result) => {
      this.generatingStatus.loadEnd();
      this.values.seed = result.data.model.seed;
      this.username = result.data.model.username;
      this.user = Object.assign(new UserProfile, result.data.model.user);
      this.options = Object.assign({}, this.options, result.data.model.options);
      if (this.options.verificationType.length > 0)
      {
        this.values.verificationType = this.options.verificationType[0].value;
      } else {
        this.values.verificationType = null;
      }
      return result.data.model.seed;
    }).catch((err) => {
      this.checkAxiosError(err);
      this.generatingStatus.loadError();
      throw err;
    })
  }

}


interface VerificationOptionsInterface extends Record<VerificationTypes|string, boolean> {
  [VerificationTypes.SMS]: boolean
}

export interface VerificationSettingsInterface extends Record<string, any>{
  user: UserProfileInterface
  verification: VerificationOptionsInterface
  pinSettingsAvail: boolean
  smsSettingsAvail: boolean
}

export class VerificationSettings implements VerificationSettingsInterface {
  user = null
  pinSettingsAvail = false
  smsSettingsAvail = true
  verification = {
    [VerificationTypes.SMS]: false,
    [VerificationTypes.TABLECODE]: false,
    [VerificationTypes.CERTIFICATE]: false,
    [VerificationTypes.PIN]: false,
    [VerificationTypes.GOOGLECODE]: false,
  }
}

export class VerificationsPanelModel extends WebFormModel {

  loadingStatus = new RemoteRequestState();

  settings: VerificationSettingsInterface = new VerificationSettings();

  loadSettings() {
    this.loadingStatus.loadStart();
    return axios.post('/webapi/security/setup', {call: 'loadSettings'})
      .then((result) => {
        this.settings = Object.assign(this.settings, result.data.settings);
        this.loadingStatus.loadEnd();
      }).catch((err) => {
        this.checkAxiosError(err);
        this.loadingStatus.loadError();
        throw err;
      });
  }
}
